import { DatePipe } from "@angular/common";
import { FormControl, FormGroup, Validators } from "@angular/forms";

export class DownloadModel {
    fileId : string;
    category : string;
	subCategory : string;
	keyword : string;
	fileType : string;
	model : string;
	title : string;
	filePath: string;
	fileVersion: string;
	releaseNote: string;
	releaseBy: string;
	remark : string;
	createBy : string;
	createTime : string;
	
	public static getFormGroup()
    {
        var form: FormGroup = new FormGroup({
            fileId: new FormControl(null),
            category: new FormControl(null, Validators.required),
            subCategory: new FormControl(null),
			keyword : new FormControl(null),
            fileType :  new FormControl(null),
            model: new FormControl(new Date()),
            title: new FormControl(null),
			filePath: new FormControl(null, Validators.required),
			fileVersion: new FormControl(null),
			releaseNote: new FormControl(null),
			releaseBy: new FormControl(null),
			remark : new FormControl(null),
            createBy: new FormControl(null),
            createTime: new FormControl(new Date())    
        });
        return form;
    }

    public static initializeFormGroup(form, arg_category, arg_subcategory, arg_keyword){
 
        form.setValue({
			fileId : null,
			category : arg_category,
			subCategory : arg_subcategory,
			keyword : arg_keyword,
			fileType : null,
			model : null,
			title : null,
			filePath: null,
			fileVersion: null,
			releaseNote: null,
			releaseBy: null,
			remark : null,
			createBy : null,
			createTime : null
        });
      }
}
